export class APIEndpoints {
  private static ENDPOINTS = {
    USERS: 'users',
    ORGANIZATIONS: 'organizations',
    FILES: 'files',
    PERSONNEL: 'personnels',
    ROLES: 'roles',
    PERMISSIONS: 'permissions',
    DASHBOARDS: 'dashboards',
    DASHBOARD_ROWS: 'dashboard-rows',
    DASHBOARD_SECTIONS: 'dashboard-sections',
    DASHBOARD_SLOTS: 'dashboard-slots',
    CAS: 'cas',
    PLAN_LEDGERS: 'plan-ledgers',
    NAERAS: 'naeras',
  };
  static USERS = {
    BASE: `${APIEndpoints.ENDPOINTS.USERS}`,

    SELF: `${APIEndpoints.ENDPOINTS.USERS}/self`,

    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.USERS}/${id}`,
    INVITATIONS: `${APIEndpoints.ENDPOINTS.USERS}/self/invitations`,

    PROFILE: (id: string) => `${APIEndpoints.ENDPOINTS.USERS}/${id}/profile`,
  };

  static ORGANIZATIONS = {
    BASE: `${APIEndpoints.ENDPOINTS.ORGANIZATIONS}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.ORGANIZATIONS}/${id}`,
    SELF: `${APIEndpoints.ENDPOINTS.ORGANIZATIONS}/self`,
    INVITATIONS: `${APIEndpoints.ENDPOINTS.ORGANIZATIONS}/invitations`,
  };

  static FILES = {
    BASE: `${APIEndpoints.ENDPOINTS.FILES}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.FILES}/${id}`,
    CREATE: `${APIEndpoints.ENDPOINTS.FILES}/upload`,
  };

  static PERSONNEL = {
    BASE: `${APIEndpoints.ENDPOINTS.PERSONNEL}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.PERSONNEL}/${id}`,
  };

  static ROLES = {
    BASE: `${APIEndpoints.ENDPOINTS.ROLES}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.ROLES}/${id}`,
  };

  static PERMISSIONS = {
    BASE: `${APIEndpoints.ENDPOINTS.PERMISSIONS}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.PERMISSIONS}/${id}`,
  };

  static DASHBOARDS = {
    BASE: `${APIEndpoints.ENDPOINTS.DASHBOARDS}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.DASHBOARDS}/${id}`,
  };

  static DASHBOARD_ROWS = {
    BASE: `${APIEndpoints.ENDPOINTS.DASHBOARD_ROWS}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.DASHBOARD_ROWS}/${id}`,
  };

  static DASHBOARD_SECTIONS = {
    BASE: `${APIEndpoints.ENDPOINTS.DASHBOARD_SECTIONS}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.DASHBOARD_SECTIONS}/${id}`,
  };

  static DASHBOARD_SLOTS = {
    BASE: `${APIEndpoints.ENDPOINTS.DASHBOARD_SLOTS}`,
    BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.DASHBOARD_SLOTS}/${id}`,
  };
  static CAS = {
    ADMINS: `${APIEndpoints.ENDPOINTS.CAS}/admins`,
    ADMIN_BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.CAS}/admins/${id}`,
    ORGANIZATIONS: `${APIEndpoints.ENDPOINTS.CAS}/organizations`,
    ORGANIZATION_BY_ID: (id: string) => `${APIEndpoints.ENDPOINTS.CAS}/organizations/${id}`,
    ORGANIZATION_PLAN: (id: string) => `${APIEndpoints.ENDPOINTS.CAS}/organizations/${id}/plan`,
    ORGANIZATION_FEATURES: (id: string) => `${APIEndpoints.ENDPOINTS.CAS}/organizations/${id}/features`,
    FEATURES: `${APIEndpoints.ENDPOINTS.CAS}/features`,
  };

  static PLAN_LEDGERS = {
    BASE: `${APIEndpoints.ENDPOINTS.PLAN_LEDGERS}`,
    AVAILABLE: `${APIEndpoints.ENDPOINTS.PLAN_LEDGERS}/organization/available`
  }

  static NAERAS = {
    CALENDAR: `${APIEndpoints.ENDPOINTS.NAERAS}/calendar`,
    DASHBOARD: `${APIEndpoints.ENDPOINTS.NAERAS}/dashboard`,
    DASHBOARD_PEZI_WATER: `${APIEndpoints.ENDPOINTS.NAERAS}/dashboard/pezi-water`,
    SETTINGS: `${APIEndpoints.ENDPOINTS.NAERAS}/settings`,

    BIDS: `${APIEndpoints.ENDPOINTS.NAERAS}/bids`,
    BID_BY_DATE: (targetDate: string) => `${APIEndpoints.ENDPOINTS.NAERAS}/bids/${targetDate}`,
    BIDS_EXPORT: `${APIEndpoints.ENDPOINTS.NAERAS}/bids/export`,
    BIDS_IMPORT: `${APIEndpoints.ENDPOINTS.NAERAS}/bids/import`,
    BIDS_FINALIZE: `${APIEndpoints.ENDPOINTS.NAERAS}/bids/finalize`,

    JOB_RUNS: `${APIEndpoints.ENDPOINTS.NAERAS}/job-runs`,
    JOB_RUNS_POOL: `${APIEndpoints.ENDPOINTS.NAERAS}/job-runs/pool`,
    JOB_RUN: (job: string, runDate: string) =>
      `${APIEndpoints.ENDPOINTS.NAERAS}/job-runs/${job}/${runDate}`,
  }

}
